module.exports = __webpack_public_path__ + "img/wheel_bg2.9c9d98a2.png";